import React from 'react'
import { Button, Col, Divider, Form, Input, Row, Select, Space } from 'antd'

import S3Upload from '@a4b/ui/src/modules/monetisation/puja/molecules/S3Upload'

interface TithiFormProps {
    form: any
    onFinish: (values: any) => void
    onCancel: () => void
    isEditing: boolean
    cdnUrl: string
    preSignUrl: string
    submitting?: boolean
}

const TithiForm: React.FC<TithiFormProps> = ({
    form,
    onFinish,
    onCancel,
    isEditing,
    cdnUrl,
    preSignUrl,
    submitting = false,
}) => {
    return (
        <Form form={form} layout="vertical" onFinish={onFinish}>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        label="Name"
                        name="name"
                        rules={[{ required: true, message: 'Please enter tithi name' }]}
                    >
                        <Input placeholder="Enter tithi name" />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Tithi Type"
                        name="tithi_type"
                        rules={[{ required: true, message: 'Please select tithi type' }]}
                    >
                        <Select placeholder="Select tithi type">
                            <Select.Option value="regular">Regular</Select.Option>
                            <Select.Option value="festival">Festival</Select.Option>
                            <Select.Option value="special">Special</Select.Option>
                        </Select>
                    </Form.Item>
                </Col>
            </Row>

            <Divider />

            <div style={{ marginBottom: 24 }}>
                <div style={{ marginBottom: 8, fontWeight: 500 }}>Add Display Name</div>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="display_name_en"
                            rules={[{ required: true, message: 'Please enter English display name' }]}
                        >
                            <Input placeholder="English" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="display_name_hi"
                            rules={[{ required: true, message: 'Please enter Hindi display name' }]}
                        >
                            <Input placeholder="Hindi" />
                        </Form.Item>
                    </Col>
                </Row>
            </div>

            <Divider />

            <Row gutter={16}>
                <Col span={8}>
                    <Form.Item
                        label="Media Type"
                        name="media_type"
                        rules={[{ required: true, message: 'Please select media type' }]}
                    >
                        <Select placeholder="Select media type">
                            <Select.Option value="image">Image</Select.Option>
                            <Select.Option value="video">Video</Select.Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={16}>
                    <Form.Item
                        label="Media"
                        name="media"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => {
                            if (Array.isArray(e)) return e
                            return e?.fileList
                        }}
                        rules={[{ required: true, message: 'Please upload media' }]}
                    >
                        <S3Upload
                            cdnUrl={cdnUrl}
                            preSignUrl={preSignUrl}
                            min={0}
                            max={1}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Divider />

            <div style={{ marginBottom: 24 }}>
                <div style={{ marginBottom: 8, fontWeight: 500 }}>Add Description</div>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="description_en"
                            rules={[{ required: true, message: 'Please enter English description' }]}
                        >
                            <Input.TextArea
                                rows={4}
                                placeholder="English Description"
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="description_hi"
                            rules={[{ required: true, message: 'Please enter Hindi description' }]}
                        >
                            <Input.TextArea
                                rows={4}
                                placeholder="Hindi Description"
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </div>

            <Form.Item>
                <Space>
                    <Button type="primary" htmlType="submit" loading={submitting} disabled={submitting}>
                        {isEditing ? 'Update' : 'Create'}
                    </Button>
                    <Button onClick={onCancel} disabled={submitting}>
                        Cancel
                    </Button>
                </Space>
            </Form.Item>
        </Form>
    )
}

export default TithiForm
